import {makeActionCreator} from '../utility'

export const FETCH_INDIVIDUAL_MEMBERSHIP = 'FETCH_INDIVIDUAL_MEMBERSHIP'
export const fetchIndividualMembership = makeActionCreator(FETCH_INDIVIDUAL_MEMBERSHIP,'data')

export const  INDIVIDUAL_MEMBERSHIP_RECEIVED = 'INDIVIDUAL_MEMBERSHIP_RECEIVED'
export const  individualMembershipReceived = makeActionCreator(INDIVIDUAL_MEMBERSHIP_RECEIVED, 'data')


export const GENERATE_MEMBERSHIP_CERETIFICATE = 'GENERATE_MEMBERSHIP_CERETIFICATE'
export const generateMembershipCertificate = makeActionCreator(GENERATE_MEMBERSHIP_CERETIFICATE, 'data')

export const MEMBERSHIP_CERETIFICATE_RECIEVED = 'MEMBERSHIP_CERETIFICATE_RECIEVED'
export const MembershipCertificateReceived = makeActionCreator(MEMBERSHIP_CERETIFICATE_RECIEVED, 'data')


export const EDIT_MEMBERSHIP = 'EDIT_MEMBERSHIP'
export const editMembership = makeActionCreator(EDIT_MEMBERSHIP, 'data')

export const HAS_EDITED_MEMBERSHIP = 'HAS_EDITED_MEMBERSHIP'
export const hasEditedMembership = makeActionCreator(HAS_EDITED_MEMBERSHIP, 'data')